/* eslint-disable no-console */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-multi-comp */
import React, { useState, useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import {
  Grid,
  Tab,
  Tabs,
  Button,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogActions,
} from '@mui/material';

// Smart Components
import RouteList from './RouteList';
import RouteMap from './RouteMap';
import NewRoute from './NewRoute';

// Actions
import {
  createRoute,
  updateRoute,
  setNewGeoJson,
  setUpdateGeoJson,
  toggleNewLineAndPoints,
  closeDeleteConfirm,
  deleteRoute,
  getRoutes,
  clearNewRoute,
  clearUpdateRoute,
  setTab,
  getBalbrigganData
} from 'actions/routePlannerActions';

// Actions
import { setNavbar, hideTopbar } from 'actions/uiActions';

const NEW_ROUTE = 0;
const UPDATE_ROUTE = 1;

const RoutePlanner = props => {
  const {
    setNavbar,
    hideTopbar,
    tab,
    getRoutes,
    deleteId,
    deleteEircode,
    deleteRoute,
    deleteRouteConfirmModalOpen,
    closeConfirmModal,
    deletingRoute,
    toggleNewLineAndPoints,
    clearNewRoute,
    clearUpdateRoute,
    setTab
  } = props;

  const [urlRoute, setUrlRoute] = useState('');
  const dispatch = useDispatch();

  useEffect(() => {
    setNavbar(false);
    hideTopbar(true);
    getRoutes();
    findUrlRoute();
    dispatch(getBalbrigganData());
    return () => {
      setNavbar(true);
      hideTopbar(false);
      clearNewRoute();
      clearUpdateRoute();
      toggleNewLineAndPoints(true);
    };
  }, []);

  const findUrlRoute = () => {
    const queryParams = new URLSearchParams(window.location.search);
    const route = queryParams.get('route');
    if (route) {
      setUrlRoute(route);
      setTab(UPDATE_ROUTE);
    }
  };

  const onTabChange = (_e, newValue) => {
    setTab(newValue);
  };

  const onDeleteRoute = () => {
    if (deleteId && deleteEircode) {
      deleteRoute(deleteId, deleteEircode);
    }
  };

  const shouldDisplayRouteMap = tab === NEW_ROUTE || tab === UPDATE_ROUTE;

  return (
    <div className="h-full overflow-hidden">
      <Grid container className="h-full overflow-hidden">
        <Grid item xs={7} className="relative">
          {shouldDisplayRouteMap && <RouteMap />}
        </Grid>
        <Grid item xs={5}>
          <Tabs
            value={tab}
            onChange={onTabChange}
            indicatorColor="primary"
            textColor="primary"
            className="border-b border-gray-200">
            <Tab label="New Route" />
            <Tab label="Route List" />
          </Tabs>
          {tab === NEW_ROUTE && <NewRoute />}
          {tab === UPDATE_ROUTE && <RouteList urlRoute={urlRoute} />}
        </Grid>
      </Grid>
      <Dialog
        open={!!deleteRouteConfirmModalOpen}
        onClose={closeConfirmModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <DialogTitle className="p-7">
          <h3 className={'text-lg font-semibold text-gray-800'}>
            {`Are you sure you want to delete route ${deleteEircode}?`}
          </h3>
        </DialogTitle>
        <DialogActions>
          <Button onClick={closeConfirmModal} color="primary">
            Cancel
          </Button>
          <Button onClick={onDeleteRoute} color="primary">
            {deletingRoute ? (
              <CircularProgress size={10} />
            ) : (
              'Yes, Delete Route'
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const mapStateToProps = state => ({
  creatingRoute: state.routePlanner.creatingRoute,
  newRouteGeoJson: state.routePlanner.newRouteGeoJson,
  updateRouteGeoJson: state.routePlanner.updateRouteGeoJson,
  updateRoute: state.routePlanner.updateRoute,
  newRoute: state.routePlanner.newRoute,
  newShowLine: state.routePlanner.newShowLine,
  deleteRouteConfirmModalOpen: state.routePlanner.openDeleteConfirm,
  deleteId: state.routePlanner.deleteId,
  deleteEircode: state.routePlanner.deleteEircode,
  deletingRoute: state.routePlanner.deletingRoute,
  tab: state.routePlanner.tab
});

const mapDispatchToProps = dispatch => ({
  getRoutes: () => dispatch(getRoutes()),
  createRoute: (eircode, lineString, name, routeModeDev) =>
    dispatch(
      createRoute(eircode, lineString, name, routeModeDev)
    ),
  sendUpdatedRoute: (eircode, lineString) =>
    dispatch(updateRoute(eircode, lineString)),
  setNewGeoJson: gJson => dispatch(setNewGeoJson(gJson)),
  setUpdateGeoJson: gJson => dispatch(setUpdateGeoJson(gJson)),
  toggleNewLineAndPoints: showLine =>
    dispatch(toggleNewLineAndPoints(showLine)),
  closeConfirmModal: () => dispatch(closeDeleteConfirm()),
  deleteRoute: (id, eircode) => dispatch(deleteRoute(id, eircode)),
  setNavbar: open => dispatch(setNavbar(open)),
  hideTopbar: hide => dispatch(hideTopbar(hide)),
  clearNewRoute: () => dispatch(clearNewRoute()),
  clearUpdateRoute: () => dispatch(clearUpdateRoute()),
  setTab: tab => dispatch(setTab(tab))
});

export default connect(mapStateToProps, mapDispatchToProps)(RoutePlanner);
